import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Label = styled.label`
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  width: 100%;
  display: block;
  font-family: 'Nunito';
  color: #676767;
  font-family: Nunito;
  font-weight: 600;
  line-height: 14px;
`

const InnerInput = styled.input`
  border: 1px solid #dedede;
  color: #3e3e3e;
  background-color: transparent;
  display: block;
  width: 100%;
  padding: 13px 12px;
  position: relative;
  transition: all 0.1s;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 14px;
  margin-top: 8px;
  height: 40px;

  &:focus {
    border-color: #93c13e;
    outline: none;
  }

  &.valid {
    border-color: #93c13e;
  }

  &.invalid {
    border-color: indianred;
  }

  ${(props) =>
    props.valid !== null && !props.valid && 'border-color: #C13E44 !important;'}
`

const Error = styled.span`
  color: #c13e44;
  font-size: 12px;
  font-weight: 400;
  ${(props) => (props.valid === null || props.valid) && 'display: none;'}
  position: absolute;
`

const onChange = (event, props) => {
  if (props.onlyNumbers) {
    const re = /^[0-9\b]+$/
    if (event.target.value && !re.test(event.target.value)) {
      return false
    }
  }

  if (props.onlyDecimalNumbers) {
    const re = /(^[0-9]$)|(^[0-9](.|,)?$)|(^[0-9](.|,){1}[0-9]+$)/
    if (event.target.value && !re.test(event.target.value)) {
      return false
    }
  }

  props.onChange(event.target.value)
}

const Input = (props) => (
  <Label>
    {props.label}
    <InnerInput
      valid={props.valid}
      value={props.value}
      type={props.type}
      autoComplete={'off'}
      onChange={(e) => onChange(e, props)}
      onBlur={(e) => props.onBlur && props.onBlur(props.validator)}
      placeholder={props.placeholder}
      maxLength={props.maxLength}
      className={props.className}
    />
    <Error valid={props.valid}>{props.errorMessage}</Error>
  </Label>
)

Input.defaultProps = {
  errorMessage: '',
  valid: true,
  placeholder: '',
}

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  autoComplete: PropTypes.string,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  valid: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  validator: PropTypes.func,
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Input/index.js